const accessSlide = (() => {

  const pageAccess = (document.getElementById("pageAccess") != null);
  const pageLocation = (document.getElementById("pageLocation") != null);
  if (pageAccess) {


    const swiper = new Swiper(".swiper", {
      loop: true, // ループ有効
      slidesPerView: 2, // 一度に表示する枚数
      speed: 6000, // ループの時間
      allowTouchMove: false, // スワイプ無効
      autoplay: {
        delay: 0, // 途切れなくループ
      },
      breakpoints: {
        // スライドの表示枚数：750px以上の場合
        750: {
          slidesPerView: 4,
        },
      },
    });

  }



  if (pageLocation) {

    const locationMain =document.querySelectorAll('.js-locaionMain');
    if (locationMain.length > 0) {
      for (let i = 0; i < locationMain.length; i++) {
  
        gsap.set([locationMain], {
          scaleY: 1,
        });
  
        gsap.to(locationMain[i], {
          scaleY: 0,
          duration: 0.6,
          ease: "power1.out",
          scrollTrigger: {
            trigger: locationMain[i],
            start: 'top 80%'
          }
        });
  
      }
    }

    const pickupBorder =document.querySelectorAll('.pickup-box .desc');
    pickupBorder.forEach((pickupBorder) => {
      ScrollTrigger.create({
        trigger: pickupBorder,
        start: 'top 80%',
        onEnter: () => {
          pickupBorder.classList.add('act');
        },
      });
    });


    const swiper = new Swiper(".gourmet-wrap .swiper", {
      loop: true, // ループ有効
      slidesPerView: 2, // 一度に表示する枚数
      speed: 6000, // ループの時間
      allowTouchMove: false, // スワイプ無効
      autoplay: {
        delay: 0, // 途切れなくループ
      },
      breakpoints: {
        // スライドの表示枚数：750px以上の場合
        750: {
          slidesPerView: 4,
        },
      },
    });

    const swiperThum = new Swiper(".restaurant-wrap .swiper2-thum", {
      slidesPerView: 3,
      spaceBetween: 15,
    })

    const swiperMain = new Swiper(".restaurant-wrap .swiper2", {
      slidesPerView: 1,
      autoplay: true,
      thumbs: {
        swiper: swiperThum,
      },
    });

    const swiperThum3 = new Swiper(".restaurant-wrap .swiper3-thum", {
      slidesPerView: 3,
      spaceBetween: 15,
    })

    const swiperMain3 = new Swiper(".restaurant-wrap .swiper3", {
      slidesPerView: 1,
      autoplay: true,
      thumbs: {
        swiper: swiperThum3,
      },
    });


  }

  // if (pageLocation) {

  //   const swiperMain = new Swiper(".swiper2", {
  //     slidesPerView: 1,
  //     speed: 500,
  //     thumbs: {
  //       swiper: swiperThum,
  //     },
  //   });

  //   const swiperThum = new Swiper(".swiper2-thum", {
  //     slidesPerView: 3, // 一度に表示する枚数
  //   });

  // }

})();
export default accessSlide;